import React from 'react';
import { FilterOption } from '../../../components/ui';
import {
  OnlyFansIc,
  InstagramIc,
  GoogleIc,
  TwitterIc,
  IcReddit,
  IcAnotherSoc,
  IcTg,
  IcTikTok,
  IcYoutube,
} from '../../../components/icons';
import { CampaignsFilters } from './types';

export const getTableColumns = (t: any) => [
  { name: 'ID', key: 'id' },
  { name: t('campaigns.table.columns.campaign'), key: 'campaign' },
  { name: t('campaigns.table.columns.statistics'), key: 'statistics' },
  { name: t('campaigns.table.columns.status'), key: 'status' },
  { name: t('campaigns.table.columns.added'), key: 'added' },
];

export const getSortOptions = (t: any): FilterOption[] => [
  { key: 'all', label: t('campaigns.filters.sort.placeholder') },
  { key: 'created_at', label: t('campaigns.filters.sort.created') || 'По дате' },
  { key: '-created_at', label: t('campaigns.filters.sort.created') || 'По дате' },
  { key: 'subscribed_count', label: t('campaigns.filters.sort.subscribers') || 'Подписчики' },
  { key: '-subscribed_count', label: t('campaigns.filters.sort.subscribers') || 'Подписчики' },
  { key: 'transactions_statistic.total', label: t('campaigns.filters.sort.revenue') || 'Доход' },
  { key: '-transactions_statistic.total', label: t('campaigns.filters.sort.revenue') || 'Доход' },
  {
    key: 'transactions_statistic.1',
    label: t('campaigns.filters.sort.transactions1') || 'Транзакции $1',
  },
  {
    key: '-transactions_statistic.1',
    label: t('campaigns.filters.sort.transactions1') || 'Транзакции $1',
  },
  {
    key: 'subs.with_gte_3_chat_messages_count',
    label: t('campaigns.filters.sort.messages') || 'Сообщения',
  },
  {
    key: '-subs.with_gte_3_chat_messages_count',
    label: t('campaigns.filters.sort.messages') || 'Сообщения',
  },
  { key: 'romi', label: 'ROMI' },
  { key: '-romi', label: 'ROMI' },
  { key: 'arpu', label: 'ARPU' },
  { key: '-arpu', label: 'ARPU' },
];

export const getCampaignStatuses = (t: any): FilterOption[] => [
  { key: 'all', label: t('campaigns.filters.status.placeholder') },
  { key: 'in_progress', label: t('campaigns.status.active') || 'В работе' },
  { key: 'in_moderation', label: t('campaigns.filters.status.moderation') || 'На модерации' },
  { key: 'waiting', label: t('campaigns.filters.status.waiting') || 'Ожидание' },
  { key: 'completed', label: t('campaigns.filters.status.completed') || 'Завершено' },
  { key: 'canceled', label: t('campaigns.status.inactive') || 'Отменено' },
];

export const getCampaignSources = (t: any): FilterOption[] => [
  { key: 'all', label: t('campaigns.filters.sources.placeholder') },
  {
    key: 'only_fans',
    label: 'OnlyFans',
    icon: React.createElement(OnlyFansIc, { size: 16, fill: '#A8A8B0' }),
  },
  { key: 'reddit', label: 'Reddit', icon: React.createElement(IcReddit, { size: 16 }) },
  {
    key: 'instagram',
    label: 'Instagram',
    icon: React.createElement(InstagramIc, { size: 16, fill: '#A8A8B0' }),
  },
  { key: 'tiktok', label: 'TikTok', icon: React.createElement(IcTikTok, { size: 16 }) },
  {
    key: 'google',
    label: 'Google',
    icon: React.createElement(GoogleIc, { size: 16, fill: '#A8A8B0' }),
  },
  { key: 'telegram', label: 'Telegram', icon: React.createElement(IcTg, { size: 16 }) },
  {
    key: 'twitter',
    label: 'Twitter',
    icon: React.createElement(TwitterIc, { size: 16, fill: '#A8A8B0' }),
  },
  { key: 'youtube', label: 'YouTube', icon: React.createElement(IcYoutube, { size: 16 }) },
  {
    key: 'another',
    label: t('campaigns.filters.sources.other'),
    icon: React.createElement(IcAnotherSoc, { size: 16 }),
  },
];

export const getCampaignTypes = (t: any): FilterOption[] => [
  { key: 'all', label: t('campaigns.filters.type.placeholder') },
  { key: 'free', label: 'FREE' },
  { key: 'free_trial', label: 'Free-trial' },
];

export const DEFAULT_FILTERS: CampaignsFilters = {
  search: '',
  sort: 'all',
  model: 'all',
  status: 'all',
  source: 'all',
  campaignType: 'all',
  fansFrom: null,
  revenueFrom: null,
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;
